import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { Modal } from "react-bootstrap";
import { ArrowRightIcon, DownloadIcon } from "@fluentui/react-icons-northstar";
import { CSVLink } from "react-csv";

import ChatTranscriptTable from "../../components/ChatTranscriptTable/ChatTranscriptTable";
import styles from "./MedinfoDashboard.module.css";
import { getMedinfoBotStats, getMedinfoExportData } from "../../utils/Api";
import { handleLoaderEvent } from "../../utils/LoaderEmitter";
import Menu from "../../components/Menu/Menu";
import KPICards from "../../components/KPICards/KPICards";

const menuItems = [
    {
        name: "Home",
        link: "/",
    },
    {
        name: "Dashboard",
        link: "/dashboard",
    },
    {
        name: "Data Catalogue",
        link: "/data-catalogue",
    },
];

interface DateSelection {
    startDate: Date;
    endDate: Date;
    color?: string | undefined;
    key?: string | undefined;
    autoFocus?: boolean | undefined;
    disabled?: boolean | undefined;
    showDateDisplay?: boolean | undefined;
}

const csvHeaders = [
    { label: "Role", key: "role" },
    { label: "Message", key: "message" },
    { label: "Time Stamp", key: "timeStamp" },
    { label: "Conversation ID", key: "convID" },
];

const parseDateForFilter = (date: Date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

const MedinfoDashboard = () => {
    // const [isOpen, setIsOpen] = useState(false);

    const [transcriptData, setTranscriptData] = useState([]);
    const [kpiStats, setKpiStats] = useState([]);
    const [addModalShow, setAddModalShow] = useState(false);
    const [csvData, setCSVData] = useState([]);

    // Default selection of 1 week range
    const [selectionRange, setSelectionRange] = useState<DateSelection>({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: "selection",
    });
    useEffect(() => {
        (async () => {
            handleLoaderEvent.emit("loader", true);
            const botStats = await getMedinfoBotStats(
                parseDateForFilter(selectionRange.startDate),
                parseDateForFilter(selectionRange.endDate)
            );
            const exportCsv = await getMedinfoExportData(
                parseDateForFilter(selectionRange.startDate),
                parseDateForFilter(selectionRange.endDate)
            );

            setTranscriptData(botStats.result?.allQues || []);
            setKpiStats(botStats.result?.stats || []);
            setCSVData(exportCsv.result || []);
            handleLoaderEvent.emit("loader", false);
        })();
    }, [selectionRange]);

    const handleDateRangeFilterSelect = (ranges: any) => {
        setSelectionRange(ranges.selection);
        addModalHandleClose();
    };

    const addModalHandleClose = () => setAddModalShow(false);

    const addModalHandleShow = () => setAddModalShow(true);

    return (
        <>
            <Menu menuItems={menuItems}></Menu>

            <div className="mt-5">
                {kpiStats.length > 0 && (
                    <div>
                        <div className={styles.tableHeaderPanel}>
                            <div className={styles.tableHeader}>KPI</div>

                            <div className={`${styles.filterRangeContainer}`}>
                                {/* <div className={styles.filterDateHeader}>
                                    Select Time Range
                                </div> */}

                                <div
                                    className={styles.filterDatesContainer}
                                    onClick={addModalHandleShow}
                                >
                                    <span className={styles.filterDateDisplay}>
                                        {selectionRange.startDate.getDate()}-
                                        {selectionRange.startDate.getMonth() +
                                            1}
                                        -
                                        {selectionRange.startDate.getFullYear()}
                                    </span>
                                    <ArrowRightIcon
                                        size="large"
                                        outline
                                        className={styles.arrowIcon}
                                    />
                                    <span className={styles.filterDateDisplay}>
                                        {selectionRange.endDate.getDate()}-
                                        {selectionRange.endDate.getMonth() + 1}-
                                        {selectionRange.endDate.getFullYear()}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.divider} />
                        <KPICards kpis={kpiStats} />
                    </div>
                )}

                {transcriptData.length > 0 && (
                    <div>
                        <div className={styles.tableHeaderPanel}>
                            <div className={styles.tableHeader}>
                                HCP Queries
                            </div>
                            <div>
                                <CSVLink
                                    filename={"Chat Transcript.csv"}
                                    data={csvData}
                                    headers={csvHeaders}
                                >
                                    <button
                                        className={`mx-2 ${styles.exportButton}`}
                                    >
                                        Download Transcript <DownloadIcon size="large" outline className={styles.downloadIcon}/>
                                    </button>
                                </CSVLink>
                            </div>
                        </div>

                        <div className={styles.divider} />
                        <ChatTranscriptTable
                            chatTranscriptList={transcriptData}
                        />
                    </div>
                )}
            </div>

            <Modal
                className="modal-lg"
                show={addModalShow}
                onHide={addModalHandleClose}
            >
                <Modal.Body>
                    <Modal.Title>Select Time Range</Modal.Title>
                    <DateRangePicker
                        ranges={[selectionRange]}
                        onChange={handleDateRangeFilterSelect}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default MedinfoDashboard;
